
    // IMPORTS
    import { defineComponent, PropType, computed } from 'vue'

    export default defineComponent({
        name: 'my-icon',

        components: {
        },

        props: {
            icon: { type: String as PropType<string>, required: true },
            size: { type: Number as PropType<number>, required: false, default: () => 24 },
            color: { type: String as PropType<string>, required: false, default: () => '' },
        },

        setup(props) {
            /********************************************************************************************************************
             COMPUTED DATA
             ********************************************************************************************************************/
            const classes = computed(() => ['k-icon', `k-i-${props.icon}`])
            const styles = computed(() => props.color != ''
                ? { fontSize: `${props.size}px`, color: props.color }
                : { fontSize: `${props.size}px` }
            )
            const computedData = { classes, styles }

            /********************************************************************************************************************
             COMPONENT INTERFACE
             ********************************************************************************************************************/
            return { ...computedData }
        }
    });
